module.exports = __webpack_public_path__ + "img/chat-screen.53174c8f.png";